import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { X_HOHR_ACT_AS } from '../core/core.constants';

export const impersonationInterceptor: HttpInterceptorFn = (
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const actAs = sessionStorage.getItem('actAs');

  return !actAs
    ? next(httpRequest)
    : next(
        httpRequest.clone({
          setHeaders: { [X_HOHR_ACT_AS]: sessionStorage.getItem('actAs') },
        })
      );
};
